(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("survey-core"), require("survey-creator-core"), require("survey-js-ui"));
	else if(typeof define === 'function' && define.amd)
		define("survey-creator-js", ["survey-core", "survey-creator-core", "survey-js-ui"], factory);
	else if(typeof exports === 'object')
		exports["survey-creator-js"] = factory(require("survey-core"), require("survey-creator-core"), require("survey-js-ui"));
	else
		root["SurveyCreator"] = factory(root["Survey"], root["SurveyCreatorCore"], root["SurveyUI"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_survey_core__, __WEBPACK_EXTERNAL_MODULE_survey_creator_core__, __WEBPACK_EXTERNAL_MODULE_survey_js_ui__) => {
return 